import {
  FbPixelEventName,
  SendFbPixelEvent,
} from '../../store/fb-pixel/service';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';

export const sendFbPixelEvent = (
  event: FbPixelEventName,
  eventId: string,
  amount?: string | number | null,
  contentCategory?: string,
) => {
  // @ts-ignore
  if (typeof fbq === 'undefined') {
    return;
  }

  if (event === FbPixelEventName.PURCHASE_FIRST_SESSION) {
    // @ts-ignore
    fbq?.('track', 'purchase_first_session', {
      value: amount,
      currency: 'EUR',
      eventId: eventId,
      content_category: contentCategory,
    });
  }

  if (event === FbPixelEventName.PURCHASE_MEMBERSHIP) {
    // @ts-ignore
    fbq?.('track', 'purchase_membership', {
      value: amount,
      currency: 'EUR',
      eventId: eventId,
      content_category: contentCategory,
    });
  }

  if (amount) {
    // @ts-ignore
    fbq?.('track', 'Purchase', {
      value: amount,
      currency: 'EUR',
      eventId: eventId,
    });
    return;
  }

  // @ts-ignore
  fbq?.('track', event, { eventId: eventId });
};

export const sendAllFbPixelEvents = (
  onSendFbPixelEvent: (data: SendFbPixelEvent, isAuthorized: boolean) => void,
  event: FbPixelEventName,
  isAuthorized: boolean,
  amount?: string | number,
  contentCategory?: string,
) => {
  const eventId = uuidv4();

  sendFbPixelEvent(event, eventId, amount, contentCategory);

  onSendFbPixelEvent(
    {
      eventName: event,
      fbc: Cookies.get('_fbc') ?? undefined,
      eventId: eventId,
      purchaseValue: amount ?? undefined,
    },
    isAuthorized,
  );
};
